import moment from 'moment'
import DeviceDetector from 'device-detector-js'

import isMobile from '../../utils/isMobile'
import isSafari from '../../utils/isSafari'

const deviceDetector = new DeviceDetector()
const device = deviceDetector.parse(navigator.userAgent)

function getDeviceInfo(props) {
    return {
        deviceSource: device.device?.type,
        deviceName: device.os?.name,
        deviceId: props.deviceId,
        deviceToken: props.deviceId,
    }
}

function generateUuid() {
    var dt = new Date().getTime()
    var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = (dt + Math.random() * 16) % 16 | 0
        dt = Math.floor(dt / 16)
        return (c == 'x' ? r : (r & 0x3) | 0x8).toString(16)
    })
    return uuid
}

function getErrorMsg(error) {
    return (
        error.response?.data?.detailMessage ||
        error.response?.data?.message ||
        error.response?.data?.detailMessage
    )
}

function getUrlParameter(sParam) {
    const queryParams = new URLSearchParams(window.location.search)
    return queryParams.get(sParam)
}

const loadScriptByURL = (id, url, callback) => {
    const isScriptExist = document.getElementById(id)

    if (!isScriptExist) {
        var script = document.createElement('script')
        script.type = 'text/javascript'
        script.src = url
        script.id = id
        script.onload = () => {
            if (callback) callback()
        }
        document.body.appendChild(script)
    }

    if (isScriptExist && callback) callback()
}

function handleFullscreen() {
    if (!isMobile()) {
        window.cyFullscreen = true
        let elem = document.getElementById('test_player')
        if (isSafari()) {
            elem.webkitRequestFullScreen && elem.webkitRequestFullScreen()
        } else {
            elem.requestFullscreen && elem.requestFullscreen()
        }
    }
}
window.cyFullscreen = false

function isInstructionResponseValid(data) {
    return (
        data &&
        data.hasOwnProperty('instruction') &&
        data.hasOwnProperty('title') &&
        data.hasOwnProperty('titleEn') &&
        data.hasOwnProperty('totalQuestion') &&
        data.hasOwnProperty('syllabus') &&
        data.hasOwnProperty('maxMarks') &&
        data.hasOwnProperty('packageId')
    )
}

function updateTestStatus(
    setTestStatus,
    obj,
    r,
    setStartName,
    redirection,
    setAllTestStatus,
    param,
    setIsExistingTestParam,
    setErrorMsg,
    setIsError,
) {
    if (r.code === 'NF_RECORD') {
        setStartName('Start Test')
    } else if (r?.code === '0') {
        switch (r?.data[param]?.state) {
            case 'Completed':
                setTestStatus({
                    data: r.data[param],
                })
                setIsExistingTestParam(true)
                redirection(obj)
                return
            case 'Started':
                setStartName('Resume Test')
                setAllTestStatus(r.data)
                return
            case 'Reset':
                setIsError(true)
                setErrorMsg('Please login again and restart the test')
                return
            default:
                setIsError(true)
                setErrorMsg('Please login again and restart the test')
        }
    }
}

function updateInstructions(
    props,
    obj,
    res,
    isPreview,
    setParam,
    setTestId,
    fetchTestStatus,
) {
    if (isInstructionResponseValid(res.data)) {
        localStorage.setItem('examName', JSON.stringify(res.data?.title))
        props.onLoad(res.data)
        props.setTestDuration(res.data.allowedDuration)
        if (!isPreview) {
            props.setPackageId(res.data.packageId)
            let param =
                obj.test_short_code + '_' + obj.roll_no + '_' + obj.test_attempt
            setParam(param)
            setTestId(res.data.id)
            fetchTestStatus(obj, res, param)
        }
    }
}

function getStartTestPayload(props, testId) {
    let data = {
        testId: testId,
        testShortCode: props.queryparam.test_short_code,
        testRollNo: props.queryparam.roll_no,
        packageId: props.packageId,
        idealTime: props.queryparam.disconnect_time * 60,
        resetCount: props.queryparam.test_attempt,
        totalTimeOfTest: props.queryparam.overall_duration * 60,
        gracePeriod: props.queryparam.grace_period * 60,
        setId: '1',
        examName: props.queryparam.exam_type,
        testGroup: props.queryparam.test_group,
        testTitle: props.instructions.testData.titleEn,
        testType: props.queryparam.test_type,
        stream: props.queryparam.stream,
        classStudying: props.queryparam.class_studying,
        examSlot: props.queryparam.exam_slot,
    }
    return data
}

function updatePropsOnGiveTestSuccess(props, res, resumeTime) {
    props.setResumedData(resumeTime)
    props.setTestStatus(res)
    props.hideTimer(false)
}

function getTestEndTime(obj) {
    return moment(
        new Date(
            obj.test_start_date +
                ' ' +
                obj.vendor_slot.split('-')[1].slice(0, 2) +
                ':' +
                obj.vendor_slot.split('-')[1].slice(2, 4),
        ),
        'YYYY-MM-DD hh:mm"',
    ).toLocaleString()
}

export {
    getStartTestPayload,
    getUrlParameter,
    loadScriptByURL,
    handleFullscreen,
    isInstructionResponseValid,
    updateTestStatus,
    updateInstructions,
    updatePropsOnGiveTestSuccess,
    getDeviceInfo,
    getTestEndTime,
    getErrorMsg,
    generateUuid,
}
